import { Icon, IconProps } from './Icon';

interface FamilyIconProps extends IconProps {
  gradient?: {
    id: string;
    stops: { offset: string; color: string }[];
  };
}

export const FamilyIcon = ({ color = '#BDC9EE', gradient, ...props }: FamilyIconProps) => (
  <Icon
    {...props}
    viewBox="0 0 45 45"
  >
    {gradient && (
      <defs>
        <linearGradient
          id={gradient.id}
          x1="80%"
          y1="20%"
          x2="20%"
          y2="80%"
        >
          {gradient.stops.map((stop, index) => (
            <stop
              key={index}
              offset={stop.offset}
              stopColor={stop.color}
            />
          ))}
        </linearGradient>
      </defs>
    )}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22.4982 13.1547C22.499 13.1547 22.4998 13.1547 22.5006 13.1547C22.4998 13.1042 22.4994 13.0536 22.4994 13.0029C22.4994 7.75801 26.7512 3.50616 31.9961 3.50616C37.241 3.50616 41.4929 7.75801 41.4929 13.0029C41.4929 18.201 37.3167 22.4236 32.1365 22.4987C32.1365 22.4993 32.1366 22.5 32.1366 22.5007C37.3167 22.5758 41.4929 26.7984 41.4929 31.9964C41.4929 37.2413 37.241 41.4932 31.9961 41.4932C27.0043 41.4932 22.912 37.6418 22.5287 32.7484C22.5091 32.7488 22.4896 32.7491 22.47 32.7493C22.0862 37.6423 17.9941 41.4932 13.0026 41.4932C7.7577 41.4932 3.50586 37.2413 3.50586 31.9964C3.50586 26.8998 7.52063 22.7409 12.5601 22.5098C12.5604 22.5031 12.5607 22.4963 12.561 22.4896C7.52112 22.2589 3.50586 18.0998 3.50586 13.0029C3.50586 7.75801 7.7577 3.50616 13.0026 3.50616C18.2475 3.50616 22.4994 7.75801 22.4994 13.0029C22.4994 13.0536 22.499 13.1042 22.4982 13.1547Z"
      fill={gradient ? `url(#${gradient.id})` : color}
    />
  </Icon>
);
